export const INITIAL_PREFS = {
  basic: { ageRange: "20 – 23", heightRange: "5′ 5″ – 5′ 7″", maritalStatus: "Never Married" },
  culture: { religion: "Christian", culture: "Open to All", language: "English" },
  location: { country: "USA", state: "California" },
  education: { qualification: "Open to All", workingWith: "Open to All", profession: "Open to All", annualIncome: "$50,000 – $100,000" },
  otherDetails: { profileManagedBy: "Open to All", diet: "Open to All" }
};
export const PREFERENCE_SECTIONS = [
  { section: "basic", title: "Basic Details", iconClass: "fa fa-calendar", fields: ["ageRange", "heightRange", "maritalStatus"] },
  { section: "culture", title: "Culture", iconClass: "fa fa-book", fields: ["religion", "culture", "language"] },
  { section: "location", title: "Location", iconClass: "fa fa-map-marker", fields: ["country", "state"] },
  { section: "education", title: "Education", iconClass: "fa fa-graduation-cap", fields: ["qualification", "workingWith", "profession", "annualIncome"] },
  { section: "otherDetails", title: "Other Details", iconClass: "fa fa-ellipsis-h", fields: ["profileManagedBy", "diet"] }
];
export const COUNTRIES = [
  { value: 'India', label: 'India' },
  { value: 'USA', label: 'United States' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Australia', label: 'Australia' },
  { value: "Kuwait", label: "Kuwait" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "South Africa", label: "South Africa" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "American Samoa", label: "American Samoa" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Anguilla", label: "Anguilla" },
  { value: "Antigua & Barbuda", label: "Antigua & Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Bermuda", label: "Bermuda" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Cape Verde", label: "Cape Verde" },
  { value: "Cayman Islands", label: "Cayman Islands" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  { value: "Congo (DRC)", label: "Congo (DRC)" },
  { value: "Congo", label: "Congo" },
  { value: "Cook Islands", label: "Cook Islands" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Cote d'Ivoire", label: "Cote d'Ivoire" },
  { value: "Croatia (Hrvatska)", label: "Croatia (Hrvatska)" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czech Republic", label: "Czech Republic" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "East Timor", label: "East Timor" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Falkland Islands", label: "Falkland Islands" },
  { value: "Faroe Islands", label: "Faroe Islands" },
  { value: "Fiji Islands", label: "Fiji Islands" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "French Guiana", label: "French Guiana" },
  { value: "French Polynesia", label: "French Polynesia" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Gibraltar", label: "Gibraltar" },
  { value: "Greece", label: "Greece" },
  { value: "Greenland", label: "Greenland" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guadeloupe", label: "Guadeloupe" },
  { value: "Guam", label: "Guam" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hong Kong SAR", label: "Hong Kong SAR" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "Korea", label: "Korea" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Macao SAR", label: "Macao SAR" },
  { value: "Macedonia", label: "Macedonia" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Martinique", label: "Martinique" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mayotte", label: "Mayotte" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands Antilles", label: "Netherlands Antilles" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Caledonia", label: "New Caledonia" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "Niue", label: "Niue" },
  { value: "Norfolk Island", label: "Norfolk Island" },
  { value: "North Korea", label: "North Korea" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Panama", label: "Panama" },
  { value: "Papua New Guinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Pitcairn Islands", label: "Pitcairn Islands" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Puerto Rico", label: "Puerto Rico" },
  { value: "Qatar", label: "Qatar" },
  { value: "Reunion", label: "Reunion" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia and Montenegro", label: "Serbia and Montenegro" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "St. Helena", label: "St. Helena" },
  { value: "St. Kitts and Nevis", label: "St. Kitts and Nevis" },
  { value: "St. Lucia", label: "St. Lucia" },
  { value: "St. Pierre and Miquelon", label: "St. Pierre and Miquelon" },
  { value: "St. Vincent & Grenadines", label: "St. Vincent & Grenadines" },
  { value: "Sudan", label: "Sudan" },
  { value: "Suriname", label: "Suriname" },
  { value: "Swaziland", label: "Swaziland" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Togo", label: "Togo" },
  { value: "Tokelau", label: "Tokelau" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Turks and Caicos Islands", label: "Turks and Caicos Islands" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Virgin Islands (British)", label: "Virgin Islands (British)" },
  { value: "Virgin Islands", label: "Virgin Islands" },
  { value: "Wallis and Futuna", label: "Wallis and Futuna" },
  { value: "Yemen", label: "Yemen" },
  { value: "Yugoslavia", label: "Yugoslavia" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" }
];
export const EDUCATION_LEVELS = [
  { value: 'High School', label: 'High School' },
  { value: 'Bachelor\'s Degree', label: 'Bachelor\'s Degree' },
  { value: 'Master\'s Degree', label: 'Master\'s Degree' },
  { value: 'PhD', label: 'PhD' },
  { value: 'Other', label: 'Other' }
];
export const RELIGIONS = [
  { value: 'Christian', label: 'Christian' },        // Largest group in US
  { value: 'Jewish', label: 'Jewish' },              // Commonly searched
  { value: 'Muslim', label: 'Muslim' },
  { value: 'Hindu', label: 'Hindu' },                // South Asian diaspora
  { value: 'Buddhist', label: 'Buddhist' },
  { value: 'Spiritual', label: 'Spiritual but not Religious' },
  { value: 'No Religion', label: 'Atheist / Agnostic' },
  { value: 'Other', label: 'Other' }
];

export const LANGUAGES = [
  { value: 'English', label: 'English' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Chinese', label: 'Chinese (Mandarin/Cantonese)' },
  { value: 'Tagalog', label: 'Tagalog / Filipino' },
  { value: 'Vietnamese', label: 'Vietnamese' },
  { value: 'French', label: 'French' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Russian', label: 'Russian' },
  { value: 'German', label: 'German' },
  { value: 'Hindi', label: 'Hindi' }, // keep for South Asian immigrants
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Other', label: 'Other' }
];

export const MONTHS = Array.from({ length: 12 }, (_, i) => ({ 
  value: String(i + 1).padStart(2, '0'), 
  label: new Date(0, i).toLocaleString('default', { month: 'long' }) 
}));
export const DAYS = Array.from({ length: 31 }, (_, i) => ({ 
  value: String(i + 1).padStart(2, '0'), 
  label: i + 1 
}));
export const YEARS = Array.from({ length: 100 }, (_, i) => ({ 
  value: new Date().getFullYear() - i, 
  label: new Date().getFullYear() - i 
}));
export const CULTURES = [
  { value: "African American", label: "African American" },
  { value: "Caucasian / White", label: "Caucasian / White" },
  { value: "Hispanic / Latino", label: "Hispanic / Latino" },
  { value: "Mexican American", label: "Mexican American" },
  { value: "Puerto Rican", label: "Puerto Rican" },
  { value: "Cuban", label: "Cuban" },
  { value: "Native American", label: "Native American" },
  { value: "Asian American", label: "Asian American" },
  { value: "Chinese American", label: "Chinese American" },
  { value: "Indian American", label: "Indian American" },
  { value: "Pakistani American", label: "Pakistani American" },
  { value: "Filipino American", label: "Filipino American" },
  { value: "Vietnamese American", label: "Vietnamese American" },
  { value: "Korean American", label: "Korean American" },
  { value: "Japanese American", label: "Japanese American" },
  { value: "Middle Eastern", label: "Middle Eastern" },
  { value: "Arab American", label: "Arab American" },
  { value: "Persian / Iranian American", label: "Persian / Iranian American" },
  { value: "Jewish", label: "Jewish" },  // Often treated as cultural identity
  { value: "Italian American", label: "Italian American" },
  { value: "Irish American", label: "Irish American" },
  { value: "German American", label: "German American" },
  { value: "Polish American", label: "Polish American" },
  { value: "French American", label: "French American" },
  { value: "Greek American", label: "Greek American" },
  { value: "Russian American", label: "Russian American" },
  { value: "Other European", label: "Other European" },
  { value: "Caribbean", label: "Caribbean" },
  { value: "African (Immigrant)", label: "African (Immigrant)" },
  { value: "Other", label: "Other" }
];

export const MARITAL_STATUS = [
  { value: "Never Married", label: "Never Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Widowed", label: "Widowed" },
  { value: "Awaiting Divorce", label: "Awaiting Divorced" },
  { value: "Annulled", label: "Annulled" },
];
export const HEIGHTS = Array.from({ length: 60 }, (_, i) => ({
  value: `${4 + Math.floor(i / 12)}ft ${i % 12}in`,
  label: `${4 + Math.floor(i / 12)}ft ${i % 12}in - ${Math.round((4 * 30.48) + (i * 2.54))}cm`,
}));
export const DIETS = [
  { value: "Omnivore", label: "Omnivore (No Restrictions)" }, // Default in US
  { value: "Vegetarian", label: "Vegetarian" },
  { value: "Pescatarian", label: "Pescatarian (Fish & Seafood)" },
  { value: "Vegan", label: "Vegan (No Animal Products)" },
  { value: "Kosher", label: "Kosher" },
  { value: "Halal", label: "Halal" },
  { value: "Other", label: "Other / Flexible" }
];

// Work with
export const OCCUPATIONS = [
{ value: "Government", label: "Government" },
  { value: "Public Sector Undertaking", label: "PSU" },
  { value: "Multinational Company (MNC)", label: "MNC" },
  { value: "Private Company", label: "Private Company" },
  { value: "Self-Employed / Business Owner", label: "Self-Employed" },
  { value: "Startup", label: "Startup" },
  { value: "NGO / Non-profit", label: "NGO" },
  { value: "Other", label: "Other" },
];
export const SUBCOMMUNITIES = {
  "FREQUENTLY USED": [
    { value: "Agarwal", label: "Agarwal" },
    { value: "Arora", label: "Arora" },
    { value: "Baniya", label: "Baniya" },
    { value: "Brahmin - Bhumihar", label: "Brahmin - Bhumihar" },
    { value: "Brahmin - Gour", label: "Brahmin - Gour" },
    { value: "Brahmin - Kanyakubja", label: "Brahmin - Kanyakubja" },
    { value: "Brahmin - Other", label: "Brahmin - Other" },
    { value: "Brahmin - Saryuparin", label: "Brahmin - Saryuparin" },
    { value: "Gupta", label: "Gupta" },
    { value: "Jat", label: "Jat" },
    { value: "Jatav", label: "Jatav" },
    { value: "Kayastha", label: "Kayastha" },
    { value: "Khatri", label: "Khatri" },
    { value: "Kshatriya", label: "Kshatriya" },
    { value: "Kurmi", label: "Kurmi" },
    { value: "Kushwaha", label: "Kushwaha" },
    { value: "Rajput", label: "Rajput" },
    { value: "Scheduled Caste (SC)", label: "Scheduled Caste (SC)" },
    { value: "Thakur", label: "Thakur" },
    { value: "Yadav", label: "Yadav" }
  ],
  "ALL COMMUNITIES": [
    { value: "24 Manai Telugu Chettiar", label: "24 Manai Telugu Chettiar" },
    { value: "96 Kuli Maratha", label: "96 Kuli Maratha" },
    { value: "96K Kokanastha", label: "96K Kokanastha" },
    { value: "Adi Andhra", label: "Adi Andhra" },
    { value: "Adi Dharmi", label: "Adi Dharmi" },
    { value: "Adi Dravida", label: "Adi Dravida" },
    { value: "Adi Karnataka", label: "Adi Karnataka" },
    { value: "Agamudayar", label: "Agamudayar" },
    { value: "Agarwal", label: "Agarwal" },
    { value: "Agnikula Kshatriya", label: "Agnikula Kshatriya" },
    { value: "Agri", label: "Agri" },
    { value: "Ahir", label: "Ahir" },
    { value: "Ahom", label: "Ahom" },
    { value: "Ambalavasi", label: "Ambalavasi" },
    { value: "Arcot", label: "Arcot" },
    { value: "Arekatica", label: "Arekatica" },
    { value: "Arora", label: "Arora" },
    { value: "Arunthathiyar", label: "Arunthathiyar" },
    { value: "Arya Vysya", label: "Arya Vysya" },
    { value: "Aryasamaj", label: "Aryasamaj" },
    { value: "Ayyaraka", label: "Ayyaraka" },
    { value: "Badaga", label: "Badaga" },
    { value: "Baghel/Pal/Gaderiya", label: "Baghel/Pal/Gaderiya" },
    { value: "Bahi", label: "Bahi" },
    { value: "Baidya", label: "Baidya" },
    { value: "Baishnab", label: "Baishnab" },
    { value: "Baishya", label: "Baishya" },
    { value: "Bajantri", label: "Bajantri" },
    { value: "Balija", label: "Balija" },
    { value: "Balija - Naidu", label: "Balija - Naidu" },
    { value: "Banayat Oriya", label: "Banayat Oriya" },
    { value: "Banik", label: "Banik" },
    { value: "Baniya", label: "Baniya" },
    { value: "Barai", label: "Barai" },
    { value: "Bari", label: "Bari" },
    { value: "Barnwal", label: "Barnwal" },
    { value: "Barujibi", label: "Barujibi" },
    { value: "Besta", label: "Besta" },
    { value: "Bhandari", label: "Bhandari" },
    { value: "Bhatia", label: "Bhatia" },
    { value: "Bhatraju", label: "Bhatraju" },
    { value: "Bhavsar", label: "Bhavsar" },
    { value: "Bhovi", label: "Bhovi" },
    { value: "Billava", label: "Billava" },
    { value: "Boya/Nayak/Naik", label: "Boya/Nayak/Naik" },
    { value: "Boyer", label: "Boyer" },
    { value: "Brahmbatt", label: "Brahmbatt" },
    { value: "Brahmin - Anavil", label: "Brahmin - Anavil" },
    { value: "Brahmin - Audichya", label: "Brahmin - Audichya" },
    { value: "Brahmin - Barendra", label: "Brahmin - Barendra" },
    { value: "Brahmin - Bhatt", label: "Brahmin - Bhatt" },
    { value: "Brahmin - Bhumihar", label: "Brahmin - Bhumihar" },
    { value: "Brahmin - Brahmbhatt", label: "Brahmin - Brahmbhatt" },
    { value: "Brahmin - Dadhich/Dadheech", label: "Brahmin - Dadhich/Dadheech" },
    { value: "Brahmin - Daivadnya", label: "Brahmin - Daivadnya" },
    { value: "Brahmin - Danua", label: "Brahmin - Danua" },
    { value: "Brahmin - Deshastha", label: "Brahmin - Deshastha" },
    { value: "Brahmin - Dhiman", label: "Brahmin - Dhiman" },
    { value: "Brahmin - Dravida", label: "Brahmin - Dravida" },
    { value: "Brahmin - Embrandiri", label: "Brahmin - Embrandiri" },
    { value: "Brahmin - Goswami", label: "Brahmin - Goswami" },
    { value: "Brahmin - Gour", label: "Brahmin - Gour" },
    { value: "Brahmin - Gowd Saraswat", label: "Brahmin - Gowd Saraswat" },
    { value: "Brahmin - Gujar Gour", label: "Brahmin - Gujar Gour" },
    { value: "Brahmin - Gurukkal", label: "Brahmin - Gurukkal" },
    { value: "Brahmin - Halua", label: "Brahmin - Halua" },
    { value: "Brahmin - Havyaka", label: "Brahmin - Havyaka" },
    { value: "Brahmin - Himachali", label: "Brahmin - Himachali" },
    { value: "Brahmin - Hoysala", label: "Brahmin - Hoysala" },
    { value: "Brahmin - Iyengar", label: "Brahmin - Iyengar" },
    { value: "Brahmin - Iyer", label: "Brahmin - Iyer" },
    { value: "Brahmin - Jangid", label: "Brahmin - Jangid" },
    { value: "Brahmin - Jhadua", label: "Brahmin - Jhadua" },
    { value: "Brahmin - Jhijhotiya", label: "Brahmin - Jhijhotiya" },
    { value: "Brahmin - Kanyakubja", label: "Brahmin - Kanyakubja" },
    { value: "Brahmin - Karhade", label: "Brahmin - Karhade" },
    { value: "Brahmin - Kashmiri Pandit", label: "Brahmin - Kashmiri Pandit" },
    { value: "Brahmin - Kokanastha", label: "Brahmin - Kokanastha" },
    { value: "Brahmin - Kota", label: "Brahmin - Kota" },
    { value: "Brahmin - Kulin", label: "Brahmin - Kulin" },
    { value: "Brahmin - Kumaoni", label: "Brahmin - Kumaoni" },
    { value: "Brahmin - Madhwa", label: "Brahmin - Madhwa" },
    { value: "Brahmin - Maithili", label: "Brahmin - Maithili" },
    { value: "Brahmin - Modh", label: "Brahmin - Modh" },
    { value: "Brahmin - Mohyal", label: "Brahmin - Mohyal" },
    { value: "Brahmin - Nagar", label: "Brahmin - Nagar" },
    { value: "Brahmin - Namboodiri", label: "Brahmin - Namboodiri" },
    { value: "Brahmin - Niyogi", label: "Brahmin - Niyogi" },
    { value: "Brahmin - Niyogi Nandavariki", label: "Brahmin - Niyogi Nandavariki" },
    { value: "Brahmin - Other", label: "Brahmin - Other" },
    { value: "Brahmin - Paliwal", label: "Brahmin - Paliwal" },
    { value: "Brahmin - Panda", label: "Brahmin - Panda" },
    { value: "Brahmin - Pareek", label: "Brahmin - Pareek" },
    { value: "Brahmin - Pushkarna", label: "Brahmin - Pushkarna" },
    { value: "Brahmin - Rarhi", label: "Brahmin - Rarhi" },
    { value: "Brahmin - Rudraj", label: "Brahmin - Rudraj" },
    { value: "Brahmin - Sakaldwipi", label: "Brahmin - Sakaldwipi" },
    { value: "Brahmin - Sanadya", label: "Brahmin - Sanadya" },
    { value: "Brahmin - Sanketi", label: "Brahmin - Sanketi" },
    { value: "Brahmin - Saraswat", label: "Brahmin - Saraswat" },
    { value: "Brahmin - Sarua", label: "Brahmin - Sarua" },
    { value: "Brahmin - Saryuparin", label: "Brahmin - Saryuparin" },
    { value: "Brahmin - Shivhalli", label: "Brahmin - Shivhalli" },
    { value: "Brahmin - Shrimali", label: "Brahmin - Shrimali" },
    { value: "Brahmin - Smartha", label: "Brahmin - Smartha" },
    { value: "Brahmin - Sri Vaishnava", label: "Brahmin - Sri Vaishnava" },
    { value: "Brahmin - Stanika", label: "Brahmin - Stanika" },
    { value: "Brahmin - Tyagi", label: "Brahmin - Tyagi" },
    { value: "Brahmin - Vaidiki", label: "Brahmin - Vaidiki" },
    { value: "Brahmin - Vaikhanasa", label: "Brahmin - Vaikhanasa" },
    { value: "Brahmin - Velanadu", label: "Brahmin - Velanadu" },
    { value: "Brahmin - Viswabrahmin", label: "Brahmin - Viswabrahmin" },
    { value: "Brahmin - Vyas", label: "Brahmin - Vyas" },
    { value: "Brahmo", label: "Brahmo" },
    { value: "Buddar", label: "Buddar" },
    { value: "Bunt (Shetty)", label: "Bunt (Shetty)" },
    { value: "CKP", label: "CKP" },
    { value: "Chalawadi Holeya", label: "Chalawadi Holeya" },
    { value: "Chambhar", label: "Chambhar" },
    { value: "Chandravanshi Kahar", label: "Chandravanshi Kahar" },
    { value: "Chasa", label: "Chasa" },
    { value: "Chattada Sri Vaishnava", label: "Chattada Sri Vaishnava" },
    { value: "Chaudary", label: "Chaudary" },
    { value: "Chaurasia", label: "Chaurasia" },
    { value: "Chekkala - Nair", label: "Chekkala - Nair" },
    { value: "Chennadasar", label: "Chennadasar" },
    { value: "Cheramar", label: "Cheramar" },
    { value: "Chettiar", label: "Chettiar" },
    { value: "Chhetri", label: "Chhetri" },
    { value: "Chippolu/Mera", label: "Chippolu/Mera" },
    { value: "Devadiga", label: "Devadiga" },
    { value: "Devanga", label: "Devanga" },
    { value: "Devar/Thevar/Mukkulathor", label: "Devar/Thevar/Mukkulathor" },
    { value: "Devendra Kula Vellalar", label: "Devendra Kula Vellalar" },
    { value: "Dhangar", label: "Dhangar" },
    { value: "Dheevara", label: "Dheevara" },
    { value: "Dhiman", label: "Dhiman" },
    { value: "Dhoba", label: "Dhoba" },
    { value: "Digambar", label: "Digambar" },
    { value: "Dommala", label: "Dommala" },
    { value: "Dusadh", label: "Dusadh" },
    { value: "Ediga", label: "Ediga" },
    { value: "Ezhava", label: "Ezhava" },
    { value: "Ezhuthachan", label: "Ezhuthachan" },
    { value: "Gabit", label: "Gabit" },
    { value: "Ganakar", label: "Ganakar" },
    { value: "Gandla", label: "Gandla" },
    { value: "Ganiga", label: "Ganiga" },
    { value: "Gatti", label: "Gatti" },
    { value: "Gavali", label: "Gavali" },
    { value: "Gavara", label: "Gavara" },
    { value: "Ghumar", label: "Ghumar" },
    { value: "Goala", label: "Goala" },
    { value: "Goswami", label: "Goswami" },
    { value: "Goud", label: "Goud" },
    { value: "Gounder", label: "Gounder" },
    { value: "Gowda", label: "Gowda" },
    { value: "Gramani", label: "Gramani" },
    { value: "Gudia", label: "Gudia" },
    { value: "Gujjar", label: "Gujjar" },
    { value: "Gupta", label: "Gupta" },
    { value: "Guptan", label: "Guptan" },
    { value: "Gurjar", label: "Gurjar" },
    { value: "Halwai", label: "Halwai" },
    { value: "Hegde", label: "Hegde" },
    { value: "Helava", label: "Helava" },
    { value: "Hugar (Jeer)", label: "Hugar (Jeer)" },
    { value: "Intercaste", label: "Intercaste" },
    { value: "Jaalari", label: "Jaalari" },
    { value: "Jaiswal", label: "Jaiswal" },
    { value: "Jandra", label: "Jandra" },
    { value: "Jangam", label: "Jangam" },
    { value: "Jat", label: "Jat" },
    { value: "Jatav", label: "Jatav" },
    { value: "Jetty Malla", label: "Jetty Malla" },
    { value: "Kachara", label: "Kachara" },
    { value: "Kaibarta", label: "Kaibarta" },
    { value: "Kakkalan", label: "Kakkalan" },
    { value: "Kalar", label: "Kalar" },
    { value: "Kalinga", label: "Kalinga" },
    { value: "Kalinga Vysya", label: "Kalinga Vysya" },
    { value: "Kalita", label: "Kalita" },
    { value: "Kalwar", label: "Kalwar" },
    { value: "Kamboj", label: "Kamboj" },
    { value: "Kamma", label: "Kamma" },
    { value: "Kamma Naidu", label: "Kamma Naidu" },
    { value: "Kammala", label: "Kammala" },
    { value: "Kaniyan", label: "Kaniyan" },
    { value: "Kansari", label: "Kansari" },
    { value: "Kanu", label: "Kanu" },
    { value: "Kapu", label: "Kapu" },
    { value: "Kapu Naidu", label: "Kapu Naidu" },
    { value: "Karana", label: "Karana" },
    { value: "Karmakar", label: "Karmakar" },
    { value: "Kartha", label: "Kartha" },
    { value: "Karuneegar", label: "Karuneegar" },
    { value: "Kasar", label: "Kasar" },
    { value: "Kashyap", label: "Kashyap" },
    { value: "Kavuthiyya/Ezhavathy", label: "Kavuthiyya/Ezhavathy" },
    { value: "Kayastha", label: "Kayastha" },
    { value: "Khandayat", label: "Khandayat" },
    { value: "Khandelwal", label: "Khandelwal" },
    { value: "Kharwar", label: "Kharwar" },
    { value: "Khatik", label: "Khatik" },
    { value: "Khatri", label: "Khatri" },
    { value: "Kirar", label: "Kirar" },
    { value: "Koli", label: "Koli" },
    { value: "Koli Patel", label: "Koli Patel" },
    { value: "Kongu Vellala Gounder", label: "Kongu Vellala Gounder" },
    { value: "Korama", label: "Korama" },
    { value: "Kori", label: "Kori" },
    { value: "Koshti", label: "Koshti" },
    { value: "Krishnavaka", label: "Krishnavaka" },
    { value: "Kshatriya", label: "Kshatriya" },
    { value: "Kshatriya - Bhavasar", label: "Kshatriya - Bhavasar" },
    { value: "Kshatriya/Raju/Varma", label: "Kshatriya/Raju/Varma" },
    { value: "Kudumbi", label: "Kudumbi" },
    { value: "Kulal", label: "Kulal" },
    { value: "Kulalar", label: "Kulalar" },
    { value: "Kulita", label: "Kulita" },
    { value: "Kumawat", label: "Kumawat" },
    { value: "Kumbara", label: "Kumbara" },
    { value: "Kumbhakar/Kumbhar", label: "Kumbhakar/Kumbhar" },
    { value: "Kumhar", label: "Kumhar" },
    { value: "Kummari", label: "Kummari" },
    { value: "Kunbi", label: "Kunbi" },
    { value: "Kurava", label: "Kurava" },
    { value: "Kuravan", label: "Kuravan" },
    { value: "Kurmi", label: "Kurmi" },
    { value: "Kurmi Kshatriya", label: "Kurmi Kshatriya" },
    { value: "Kuruba", label: "Kuruba" },
    { value: "Kuruhina Shetty", label: "Kuruhina Shetty" },
    { value: "Kurumbar", label: "Kurumbar" },
    { value: "Kurup", label: "Kurup" },
    { value: "Kushwaha", label: "Kushwaha" },
    { value: "Lambadi/Banjara", label: "Lambadi/Banjara" },
    { value: "Lambani", label: "Lambani" },
    { value: "Leva Patil", label: "Leva Patil" },
    { value: "Lingayath", label: "Lingayath" },
    { value: "Lohana", label: "Lohana" },
    { value: "Lohar", label: "Lohar" },
    { value: "Loniya/Lonia/Lunia", label: "Loniya/Lonia/Lunia" },
    { value: "Lubana", label: "Lubana" },
    { value: "Madhesiya", label: "Madhesiya" },
    { value: "Madiga", label: "Madiga" },
    { value: "Mahajan", label: "Mahajan" },
    { value: "Mahar", label: "Mahar" },
    { value: "Mahendra", label: "Mahendra" },
    { value: "Maheshwari", label: "Maheshwari" },
    { value: "Mahindra", label: "Mahindra" },
    { value: "Mahishya", label: "Mahishya" },
    { value: "Majabi", label: "Majabi" },
    { value: "Mala", label: "Mala" },
    { value: "Malayalee Variar", label: "Malayalee Variar" },
    { value: "Mali", label: "Mali" },
    { value: "Mallah", label: "Mallah" },
    { value: "Mangalorean", label: "Mangalorean" },
    { value: "Maniyani", label: "Maniyani" },
    { value: "Mannadiar", label: "Mannadiar" },
    { value: "Mannan", label: "Mannan" },
    { value: "Mapila", label: "Mapila" },
    { value: "Marar", label: "Marar" },
    { value: "Maratha", label: "Maratha" },
    { value: "Maratha - Gomantak", label: "Maratha - Gomantak" },
    { value: "Maruthuvar", label: "Maruthuvar" },
    { value: "Marvar", label: "Marvar" },
    { value: "Marwari", label: "Marwari" },
    { value: "Matang", label: "Matang" },
    { value: "Maurya", label: "Maurya" },
    { value: "Meda", label: "Meda" },
    { value: "Medara", label: "Medara" },
    { value: "Meena", label: "Meena" },
    { value: "Meenavar", label: "Meenavar" },
    { value: "Meghwal", label: "Meghwal" },
    { value: "Mehra", label: "Mehra" },
    { value: "Menon", label: "Menon" },
    { value: "Meru Darji", label: "Meru Darji" },
    { value: "Modak", label: "Modak" },
    { value: "Mogaveera", label: "Mogaveera" },
    { value: "Monchi", label: "Monchi" },
    { value: "Mudaliar", label: "Mudaliar" },
    { value: "Mudaliar - Arcot", label: "Mudaliar - Arcot" },
    { value: "Mudaliar - Saiva", label: "Mudaliar - Saiva" },
    { value: "Mudaliar - Senguntha", label: "Mudaliar - Senguntha" },
    { value: "Mudiraj", label: "Mudiraj" },
    { value: "Munnuru Kapu", label: "Munnuru Kapu" },
    { value: "Muthuraja", label: "Muthuraja" },
    { value: "Naagavamsam", label: "Naagavamsam" },
    { value: "Nadar", label: "Nadar" },
    { value: "Nagaralu", label: "Nagaralu" },
    { value: "Nai", label: "Nai" },
    { value: "Naicken", label: "Naicken" },
    { value: "Naicker", label: "Naicker" },
    { value: "Naidu", label: "Naidu" },
    { value: "Naik", label: "Naik" },
    { value: "Nair", label: "Nair" },
    { value: "Nair - Vaniya", label: "Nair - Vaniya" },
    { value: "Nair - Velethadathu", label: "Nair - Velethadathu" },
    { value: "Nair - Vilakkithala", label: "Nair - Vilakkithala" },
    { value: "Namasudra", label: "Namasudra" },
    { value: "Nambiar", label: "Nambiar" },
    { value: "Nambisan", label: "Nambisan" },
    { value: "Namdev", label: "Namdev" },
    { value: "Namosudra", label: "Namosudra" },
    { value: "Napit", label: "Napit" },
    { value: "Nayak", label: "Nayak" },
    { value: "Nayaka", label: "Nayaka" },
    { value: "Neeli", label: "Neeli" },
    { value: "Nhavi", label: "Nhavi" },
    { value: "OBC - Barber/Naayee", label: "OBC - Barber/Naayee" },
    { value: "Oswal", label: "Oswal" },
    { value: "Otari", label: "Otari" },
    { value: "Padmasali", label: "Padmasali" },
    { value: "Panchal", label: "Panchal" },
    { value: "Pandaram", label: "Pandaram" },
    { value: "Panicker", label: "Panicker" },
    { value: "Paravan", label: "Paravan" },
    { value: "Parit", label: "Parit" },
    { value: "Parkava Kulam", label: "Parkava Kulam" },
    { value: "Partraj", label: "Partraj" },
    { value: "Pasi", label: "Pasi" },
    { value: "Paswan", label: "Paswan" },
    { value: "Patel", label: "Patel" },
    { value: "Patel - Desai", label: "Patel - Desai" },
    { value: "Patel - Dodia", label: "Patel - Dodia" },
    { value: "Patel - Kadva", label: "Patel - Kadva" },
    { value: "Patel - Leva", label: "Patel - Leva" },
    { value: "Patnaick", label: "Patnaick" },
    { value: "Patra", label: "Patra" },
    { value: "Patwa", label: "Patwa" },
    { value: "Perika", label: "Perika" },
    { value: "Pillai", label: "Pillai" },
    { value: "Pisharody", label: "Pisharody" },
    { value: "Poduval", label: "Poduval" },
    { value: "Poosala", label: "Poosala" },
    { value: "Porwal", label: "Porwal" },
    { value: "Prajapati", label: "Prajapati" },
    { value: "Pulaya", label: "Pulaya" },
    { value: "Raigar", label: "Raigar" },
    { value: "Rajaka/Chakali/Dhobi", label: "Rajaka/Chakali/Dhobi" },
    { value: "Rajbhar", label: "Rajbhar" },
    { value: "Rajput", label: "Rajput" },
    { value: "Rajput - Kumaoni", label: "Rajput - Kumaoni" },
    { value: "Rajput - Lodhi", label: "Rajput - Lodhi" },
    { value: "Ramdasia", label: "Ramdasia" },
    { value: "Ramgharia", label: "Ramgharia" },
    { value: "Rauniyar", label: "Rauniyar" },
    { value: "Ravidasia", label: "Ravidasia" },
    { value: "Rawat", label: "Rawat" },
    { value: "Reddiar", label: "Reddiar" },
    { value: "Reddy", label: "Reddy" },
    { value: "Relli", label: "Relli" },
    { value: "SSK", label: "SSK" },
    { value: "Sadgop", label: "Sadgop" },
    { value: "Sagara - Uppara", label: "Sagara - Uppara" },
    { value: "Saha", label: "Saha" },
    { value: "Sahu", label: "Sahu" },
    { value: "Saini", label: "Saini" },
    { value: "Saiva Vellala", label: "Saiva Vellala" },
    { value: "Saliya", label: "Saliya" },
    { value: "Sambava", label: "Sambava" },
    { value: "Satnami", label: "Satnami" },
    { value: "Savji", label: "Savji" },
    { value: "Scheduled Caste (SC)", label: "Scheduled Caste (SC)" },
    { value: "Scheduled Tribe (ST)", label: "Scheduled Tribe (ST)" },
    { value: "Senai Thalaivar", label: "Senai Thalaivar" },
    { value: "Sepahia", label: "Sepahia" },
    { value: "Setti Balija", label: "Setti Balija" },
    { value: "Shah", label: "Shah" },
    { value: "Shilpkar", label: "Shilpkar" },
    { value: "Shimpi", label: "Shimpi" },
    { value: "Sindhi - Bhanusali", label: "Sindhi - Bhanusali" },
    { value: "Sindhi - Bhatia", label: "Sindhi - Bhatia" },
    { value: "Sindhi - Chhapru", label: "Sindhi - Chhapru" },
    { value: "Sindhi - Dadu", label: "Sindhi - Dadu" },
    { value: "Sindhi - Hyderabadi", label: "Sindhi - Hyderabadi" },
    { value: "Sindhi - Larai", label: "Sindhi - Larai" },
    { value: "Sindhi - Lohana", label: "Sindhi - Lohana" },
    { value: "Sindhi - Rohiri", label: "Sindhi - Rohiri" },
    { value: "Sindhi - Sehwani", label: "Sindhi - Sehwani" },
    { value: "Sindhi - Thatai", label: "Sindhi - Thatai" },
    { value: "Sindhi-Amil", label: "Sindhi-Amil" },
    { value: "Sindhi-Baibhand", label: "Sindhi-Baibhand" },
    { value: "Sindhi-Larkana", label: "Sindhi-Larkana" },
    { value: "Sindhi-Sahiti", label: "Sindhi-Sahiti" },
    { value: "Sindhi-Sakkhar", label: "Sindhi-Sakkhar" },
    { value: "Sindhi-Shikarpuri", label: "Sindhi-Shikarpuri" },
    { value: "Somvanshi", label: "Somvanshi" },
    { value: "Sonar", label: "Sonar" },
    { value: "Soni", label: "Soni" },
    { value: "Sozhiya Vellalar", label: "Sozhiya Vellalar" },
    { value: "Sri Vaishnava", label: "Sri Vaishnava" },
    { value: "Srisayana", label: "Srisayana" },
    { value: "Subarna Banik", label: "Subarna Banik" },
    { value: "Sugali (Naika)", label: "Sugali (Naika)" },
    { value: "Sundhi", label: "Sundhi" },
    { value: "Surya Balija", label: "Surya Balija" },
    { value: "Sutar", label: "Sutar" },
    { value: "Suthar", label: "Suthar" },
    { value: "Swakula Sali", label: "Swakula Sali" },
    { value: "Swarnakar", label: "Swarnakar" },
    { value: "Tamboli", label: "Tamboli" },
    { value: "Tanti", label: "Tanti" },
    { value: "Tantuway", label: "Tantuway" },
    { value: "Telaga", label: "Telaga" },
    { value: "Teli", label: "Teli" },
    { value: "Thachar", label: "Thachar" },
    { value: "Thakkar", label: "Thakkar" },
    { value: "Thakur", label: "Thakur" },
    { value: "Thandan", label: "Thandan" },
    { value: "Thigala", label: "Thigala" },
    { value: "Thiyya", label: "Thiyya" },
    { value: "Thuluva Vellalar", label: "Thuluva Vellalar" },
    { value: "Tili", label: "Tili" },
    { value: "Togata", label: "Togata" },
    { value: "Turupu Kapu", label: "Turupu Kapu" },
    { value: "Udayar", label: "Udayar" },
    { value: "Urali Gounder", label: "Urali Gounder" },
    { value: "Urs", label: "Urs" },
    { value: "Vada Balija", label: "Vada Balija" },
    { value: "Vadagalai", label: "Vadagalai" },
    { value: "Vaddera", label: "Vaddera" },
    { value: "Vaduka", label: "Vaduka" },
    { value: "Vaish", label: "Vaish" },
    { value: "Vaish - Dhaneshawat", label: "Vaish - Dhaneshawat" },
    { value: "Vaishnav", label: "Vaishnav" },
    { value: "Vaishnav - Bhatia", label: "Vaishnav - Bhatia" },
    { value: "Vaishnav - Vania", label: "Vaishnav - Vania" },
    { value: "Vaishya", label: "Vaishya" },
    { value: "Vallala", label: "Vallala" },
    { value: "Valluvan", label: "Valluvan" },
    { value: "Valmiki", label: "Valmiki" },
    { value: "Vanika Vyshya", label: "Vanika Vyshya" },
    { value: "Vaniya Chettiar", label: "Vaniya Chettiar" },
    { value: "Vanjara", label: "Vanjara" },
    { value: "Vankar", label: "Vankar" },
    { value: "Vannan", label: "Vannan" },
    { value: "Vannar", label: "Vannar" },
    { value: "Vanniyakullak Kshatriya", label: "Vanniyakullak Kshatriya" },
    { value: "Vanniyar", label: "Vanniyar" },
    { value: "Variar", label: "Variar" },
    { value: "Varshney", label: "Varshney" },
    { value: "Veerashaiva", label: "Veerashaiva" },
    { value: "Velaan", label: "Velaan" },
    { value: "Velama", label: "Velama" },
    { value: "Velar", label: "Velar" },
    { value: "Vellalar", label: "Vellalar" },
    { value: "Veluthedathu - Nair", label: "Veluthedathu - Nair" },
    { value: "Vettuva Gounder", label: "Vettuva Gounder" },
    { value: "Vishwakarma", label: "Vishwakarma" },
    { value: "Viswabrahmin", label: "Viswabrahmin" },
    { value: "Vokkaliga", label: "Vokkaliga" },
    { value: "Vysya", label: "Vysya" },
    { value: "Waada Balija", label: "Waada Balija" },
    { value: "Yadav", label: "Yadav" },
    { value: "Yellapu", label: "Yellapu" },
    { value: "Other", label: "Other" }
  ]
};
export const PROFESSIONS = {
  "Accounting, Banking & Finance": [
    { value: "Banking Professional", label: "Banking Professional" },
    { value: "Chartered Accountant", label: "Chartered Accountant" },
    { value: "Company Secretary", label: "Company Secretary" },
    { value: "Finance Professional", label: "Finance Professional" },
    { value: "Investment Professional", label: "Investment Professional" },
    { value: "Accounting Professional (Others)", label: "Accounting Professional (Others)" }
  ],
  "Administration & HR": [
    { value: "Admin Professional", label: "Admin Professional" },
    { value: "Human Resources Professional", label: "Human Resources Professional" }
  ],
  "Advertising, Media & Entertainment": [
    { value: "Actor", label: "Actor" },
    { value: "Advertising Professional", label: "Advertising Professional" },
    { value: "Entertainment Professional", label: "Entertainment Professional" },
    { value: "Event Manager", label: "Event Manager" },
    { value: "Journalist", label: "Journalist" },
    { value: "Media Professional", label: "Media Professional" },
    { value: "Public Relations Professional", label: "Public Relations Professional" }
  ],
  "Agriculture": [
    { value: "Farming", label: "Farming" },
    { value: "Horticulturist", label: "Horticulturist" },
    { value: "Agricultural Professional (Others)", label: "Agricultural Professional (Others)" }
  ],
  "Airline & Aviation": [
    { value: "Air Hostess / Flight Attendant", label: "Air Hostess / Flight Attendant" },
    { value: "Pilot / Co-Pilot", label: "Pilot / Co-Pilot" },
    { value: "Other Airline Professional", label: "Other Airline Professional" }
  ],
  "Architecture & Design": [
    { value: "Architect", label: "Architect" },
    { value: "Interior Designer", label: "Interior Designer" },
    { value: "Landscape Architect", label: "Landscape Architect" }
  ],
  "Artists, Animators & Web Designers": [
    { value: "Animator", label: "Animator" },
    { value: "Commercial Artist", label: "Commercial Artist" },
    { value: "Web / UX Designers", label: "Web / UX Designers" },
    { value: "Artist (Others)", label: "Artist (Others)" }
  ],
  "Beauty, Fashion & Jewellery Designers": [
    { value: "Beautician", label: "Beautician" },
    { value: "Fashion Designer", label: "Fashion Designer" },
    { value: "Hairstylist", label: "Hairstylist" },
    { value: "Jewellery Designer", label: "Jewellery Designer" },
    { value: "Designer (Others)", label: "Designer (Others)" }
  ],
  "BPO, KPO, & Customer Support": [
    { value: "Customer Support / BPO / KPO Professional", label: "Customer Support / BPO / KPO Professional" }
  ],
  "Civil Services / Law Enforcement": [
    { value: "IAS / IRS / IES / IFS", label: "IAS / IRS / IES / IFS" },
    { value: "Indian Police Services [IPS]", label: "Indian Police Services [IPS]" },
    { value: "Law Enforcement Employee (Others)", label: "Law Enforcement Employee (Others)" }
  ],
  "Defense": [
    { value: "Airforce", label: "Airforce" },
    { value: "Army", label: "Army" },
    { value: "Navy", label: "Navy" },
    { value: "Defense Services (Others)", label: "Defense Services (Others)" }
  ],
  "Education & Training": [
    { value: "Lecturer", label: "Lecturer" },
    { value: "Professor", label: "Professor" },
    { value: "Research Assistant", label: "Research Assistant" },
    { value: "Research Scholar", label: "Research Scholar" },
    { value: "Teacher", label: "Teacher" },
    { value: "Training Professional (Others)", label: "Training Professional (Others)" }
  ],
  "Engineering": [
    { value: "Civil Engineer", label: "Civil Engineer" },
    { value: "Electronics / Telecom Engineer", label: "Electronics / Telecom Engineer" },
    { value: "Mechanical / Production Engineer", label: "Mechanical / Production Engineer" },
    { value: "Non IT Engineer (Others)", label: "Non IT Engineer (Others)" }
  ],
  "Hotel & Hospitality": [
    { value: "Chef / Sommelier / Food Critic", label: "Chef / Sommelier / Food Critic" },
    { value: "Catering Professional", label: "Catering Professional" },
    { value: "Hotel & Hospitality Professional (Others)", label: "Hotel & Hospitality Professional (Others)" }
  ],
  "IT & Software Engineering": [
    { value: "Software Developer / Programmer", label: "Software Developer / Programmer" },
    { value: "Software Consultant", label: "Software Consultant" },
    { value: "Hardware & Networking professional", label: "Hardware & Networking professional" },
    { value: "Software Professional (Others)", label: "Software Professional (Others)" }
  ],
  "Legal": [
    { value: "Lawyer", label: "Lawyer" },
    { value: "Legal Assistant", label: "Legal Assistant" },
    { value: "Legal Professional (Others)", label: "Legal Professional (Others)" }
  ],
  "Medical & Healthcare": [
    { value: "Dentist", label: "Dentist" },
    { value: "Doctor", label: "Doctor" },
    { value: "Medical Transcriptionist", label: "Medical Transcriptionist" },
    { value: "Nurse", label: "Nurse" },
    { value: "Pharmacist", label: "Pharmacist" },
    { value: "Physician Assistant", label: "Physician Assistant" },
    { value: "Physiotherapist / Occupational Therapist", label: "Physiotherapist / Occupational Therapist" },
    { value: "Psychologist", label: "Psychologist" },
    { value: "Surgeon", label: "Surgeon" },
    { value: "Veterinary Doctor", label: "Veterinary Doctor" },
    { value: "Therapist (Others)", label: "Therapist (Others)" },
    { value: "Medical / Healthcare Professional (Others)", label: "Medical / Healthcare Professional (Others)" }
  ],
  "Merchant Navy": [
    { value: "Merchant Naval Officer", label: "Merchant Naval Officer" },
    { value: "Mariner", label: "Mariner" }
  ],
  "Sales & Marketing": [
    { value: "Marketing Professional", label: "Marketing Professional" },
    { value: "Sales Professional", label: "Sales Professional" }
  ],
  "Science": [
    { value: "Biologist / Botanist", label: "Biologist / Botanist" },
    { value: "Physicist", label: "Physicist" },
    { value: "Science Professional (Others)", label: "Science Professional (Others)" }
  ],
  "Corporate Professionals": [
    { value: "CxO / Chairman / Director / President", label: "CxO / Chairman / Director / President" },
    { value: "VP / AVP / GM / DGM", label: "VP / AVP / GM / DGM" },
    { value: "Sr. Manager / Manager", label: "Sr. Manager / Manager" },
    { value: "Consultant / Supervisor / Team Leads", label: "Consultant / Supervisor / Team Leads" },
    { value: "Team Member / Staff", label: "Team Member / Staff" }
  ],
  "Others": [
    { value: "Agent / Broker / Trader / Contractor", label: "Agent / Broker / Trader / Contractor" },
    { value: "Business Owner / Entrepreneur", label: "Business Owner / Entrepreneur" },
    { value: "Politician", label: "Politician" },
    { value: "Social Worker / Volunteer / NGO", label: "Social Worker / Volunteer / NGO" },
    { value: "Sportsman", label: "Sportsman" },
    { value: "Travel & Transport Professional", label: "Travel & Transport Professional" },
    { value: "Writer", label: "Writer" }
  ]
};
export const DIET =  [
  { value: "Omnivore", label: "Omnivore (No Restrictions)" }, // Default in US
  { value: "Vegetarian", label: "Vegetarian" },
  { value: "Pescatarian", label: "Pescatarian (Fish & Seafood)" },
  { value: "Vegan", label: "Vegan (No Animal Products)" },
  { value: "Kosher", label: "Kosher" },
  { value: "Halal", label: "Halal" },
  { value: "Other", label: "Other / Flexible" }
];
export const PROFILEMANAGEDBY = [
  { value: "Self", label: "Self" },
  { value: "Parent", label: "Parent" },
  { value: "Sibling", label: "Sibling" },
  { value: "Friend", label: "Friend" },
  { value: "Relative", label: "Relative" },
  { value: "Other", label: "Other" }
];
export const QUALIFICATIONS = [
  { value: "High School", label: "High School" },
  { value: "Intermediate", label: "Intermediate" },
  { value: "Diploma", label: "Diploma" },
  { value: "Bachelors", label: "Bachelors" },
  { value: "Masters", label: "Masters" },
  { value: 'PhD', label: 'PhD' },
  { value: 'Other', label: 'Other' }
]
export const STATE = {
    "USA": [
    { value: "California", label: "California" },
    { value: "Texas", label: "Texas" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "Illinois", label: "Illinois" },
    { value: "New York", label: "New York" },
    { value: "Washington", label: "Washington" },
    { value: "Massachusetts", label: "Massachusetts" }
  ],
  "India": [
  { value: "Andhra Pradesh", label: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
  { value: "Assam", label: "Assam" },
  { value: "Bihar", label: "Bihar" },
  { value: "Chhattisgarh", label: "Chhattisgarh" },
  { value: "Goa", label: "Goa" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Haryana", label: "Haryana" },
  { value: "Himachal Pradesh", label: "Himachal Pradesh" },
  { value: "Jharkhand", label: "Jharkhand" },
  { value: "Karnataka", label: "Karnataka" },
  { value: "Kerala", label: "Kerala" },
  { value: "Madhya Pradesh", label: "Madhya Pradesh" },
  { value: "Maharashtra", label: "Maharashtra" },
  { value: "Manipur", label: "Manipur" },
  { value: "Meghalaya", label: "Meghalaya" },
  { value: "Mizoram", label: "Mizoram" },
  { value: "Nagaland", label: "Nagaland" },
  { value: "Odisha", label: "Odisha" },
  { value: "Punjab", label: "Punjab" },
  { value: "Rajasthan", label: "Rajasthan" },
  { value: "Sikkim", label: "Sikkim" },
  { value: "Tamil Nadu", label: "Tamil Nadu" },
  { value: "Telangana", label: "Telangana" },
  { value: "Tripura", label: "Tripura" },
  { value: "Uttar Pradesh", label: "Uttar Pradesh" },
  { value: "Uttarakhand", label: "Uttarakhand" },
  { value: "West Bengal", label: "West Bengal" },

  // Union Territories
  { value: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
  { value: "Chandigarh", label: "Chandigarh" },
  { value: "Dadra and Nagar Haveli and Daman and Diu", label: "Dadra and Nagar Haveli and Daman and Diu" },
  { value: "Delhi", label: "Delhi NCR" },
  { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
  { value: "Ladakh", label: "Ladakh" },
  { value: "Lakshadweep", label: "Lakshadweep" },
  { value: "Puducherry", label: "Puducherry" }
],
  "United Arab Emirates": [
    { value: "Dubai", label: "Dubai" },
    { value: "Abu Dhabi", label: "Abu Dhabi" },
    { value: "Sharjah", label: "Sharjah" },
    { value: "Ajman", label: "Ajman" },
    { value: "Ras Al Khaimah", label: "Ras Al Khaimah" }
  ],
  "Saudi Arabia": [
    { value: "Riyadh Province", label: "Riyadh" },
    { value: "Eastern Province", label: "Eastern Province" },
    { value: "Mecca Province", label: "Mecca" },
    { value: "Medina Province", label: "Medina" }
  ],
  "Canada": [
    { value: "Ontario", label: "Ontario" },
    { value: "British Columbia", label: "British Columbia" },
    { value: "Alberta", label: "Alberta" },
    { value: "Quebec", label: "Quebec" },
    { value: "Manitoba", label: "Manitoba" }
  ],
  "Australia": [
    { value: "New South Wales", label: "New South Wales" },
    { value: "Victoria", label: "Victoria" },
    { value: "Western Australia", label: "Western Australia" },
    { value: "Queensland", label: "Queensland" },
    { value: "South Australia", label: "South Australia" }
  ],
  "UK": [
    { value: "England", label: "England" },
    { value: "Scotland", label: "Scotland" },
    { value: "Wales", label: "Wales" },
    { value: "Northern Ireland", label: "Northern Ireland" },
    { value: "Greater London", label: "Greater London" }
  ],
  "Singapore": [
    { value: "Central Region", label: "Central Singapore" },
    { value: "West Region", label: "West Singapore" },
    { value: "East Region", label: "East Singapore" },
    { value: "North Region", label: "North Singapore" },
    { value: "North-East Region", label: "North-East Singapore" }
  ],
  "Germany": [
    { value: "Bavaria", label: "Bavaria" },
    { value: "Baden-Württemberg", label: "Baden-Württemberg" },
    { value: "Hesse", label: "Hesse" },
    { value: "North Rhine-Westphalia", label: "NRW" },
    { value: "Berlin", label: "Berlin" }
  ],
  "Malaysia": [
    { value: "Kuala Lumpur", label: "Kuala Lumpur" },
    { value: "Selangor", label: "Selangor" },
    { value: "Penang", label: "Penang" },
    { value: "Johor", label: "Johor" },
    { value: "Sarawak", label: "Sarawak" }
  ]
};
export const BLOODGROUP = [
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" }
];
export const MOTHERDETAILS = [
  { value: 'Homemaker', label: 'Homemaker' },
  { value: 'Teacher', label: 'Teacher' },
  { value: 'Doctor', label: 'Doctor' },
  { value: 'Engineer', label: 'Engineer' },
  { value: 'Businesswoman', label: 'Businesswoman' }
];
export const FATHERDETAILS = [
  { value: 'Businessman', label: 'Businessman' },
  { value: 'Government employee', label: 'Government employee' },
  { value: 'Teacher', label: 'Teacher' },
  { value: 'Doctor', label: 'Doctor' },
  { value: 'Engineer', label: 'Engineer' }
];
export const NUMOFSIBLINGS = [
  { value: '0', label: 'None' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4+', label: '4+' }
];
export const FINANCIALSTATUS = [
  { value: "Affluent / Wealthy", label: "Affluent / Wealthy" },
  { value: "Upper Middle Class", label: "Upper Middle Class" },
  { value: "Middle Class", label: "Middle Class" },
  { value: "Working Class / Aspiring", label: "Working Class / Aspiring" }
];

export const HOBBIES = [
  { value: 'Writing', label: 'Writing' },
  { value: 'Cooking', label: 'Cooking' },
  { value: 'Singing', label: 'Singing' },
  { value: 'Photography', label: 'Photography' },
  { value: 'Playing instruments', label: 'Playing instruments' },
  { value: 'Painting', label: 'Painting' },
  { value: 'DIY crafts', label: 'DIY crafts' },
  { value: 'Dancing', label: 'Dancing' },
  { value: 'Acting', label: 'Acting' },
  { value: 'Poetry', label: 'Poetry' },
  { value: 'Gardening', label: 'Gardening' },
  { value: 'Blogging', label: 'Blogging' },
  { value: 'Content creation', label: 'Content creation' },
  { value: 'Designing', label: 'Designing' },
  { value: 'Doodling', label: 'Doodling' },
  { value: 'Movies', label: 'Movies' },
  { value: 'Music', label: 'Music' },
  { value: 'Travelling', label: 'Travelling' },
  { value: 'Reading', label: 'Reading' },
  { value: 'Sports', label: 'Sports' },
  { value: 'Social media', label: 'Social media' },
  { value: 'Gaming', label: 'Gaming' },
  { value: 'Binge-watching', label: 'Binge-watching' },
  { value: 'Biking', label: 'Biking' },
  { value: 'Clubbing', label: 'Clubbing' },
  { value: 'Shopping', label: 'Shopping' },
  { value: 'Theater & Events', label: 'Theater & Events' },
  { value: 'Anime', label: 'Anime' },
  { value: 'Stand ups', label: 'Stand ups' },
  { value: 'Running', label: 'Running' },
  { value: 'Cycling', label: 'Cycling' },
  { value: 'Yoga & Meditation', label: 'Yoga & Meditation' },
  { value: 'Walking', label: 'Walking' },
  { value: 'Working Out', label: 'Working Out' },
  { value: 'Trekking', label: 'Trekking' },
  { value: 'Areobics/Zumba', label: 'Areobics/Zumba' },
  { value: 'Swimming', label: 'Swimming' },
  { value: 'Pets', label: 'Pets' },
  { value: 'Foodie', label: 'Foodie' },
  { value: 'Vegan', label: 'Vegan' },
  { value: 'News & Politics', label: 'News & Politics' },
  { value: 'Social Service', label: 'Social Service' },
  { value: 'Entrepreneurship', label: 'Entrepreneurship' },
  { value: 'Home Decore', label: 'Home Decore' },
  { value: 'Investment', label: 'Investment' },
  { value: 'Fashion & Beauty', label: 'Fashion & Beauty' }
];

// src/data/astroData.js
export const RASHI_OPTIONS = [
  { key: "Aries (Mesh)", label: "Aries (Mesh)" },
  { key: "Taurus (Vrishabh)", label: "Taurus (Vrishabh)" },
  { key: "Gemini (Mithun)", label: "Gemini (Mithun)" },
  { key: "Cancer (Karka)", label: "Cancer (Karka)" },
  { key: "Leo (Simha)", label: "Leo (Simha)" },
  { key: "Virgo (Kanya)", label: "Virgo (Kanya)" },
  { key: "Libra (Tula)", label: "Libra (Tula)" },
  { key: "Scorpio (Vrischik)", label: "Scorpio (Vrischik)" },
  { key: "Sagittarius (Dhanu)", label: "Sagittarius (Dhanu)" },
  { key: "Capricorn (Makar)", label: "Capricorn (Makar)" },
  { key: "Aquarius (Kumbh)", label: "Aquarius (Kumbh)" },
  { key: "Pisces (Meen)", label: "Pisces (Meen)" }
];


export const NAKSHATRA_OPTIONS = [
  { key: "Ashwini", label: "Ashwini" },
  { key: "Bharani", label: "Bharani" },
  { key: "Krittika", label: "Krittika" },
  { key: "Rohini", label: "Rohini" },
  { key: "Mrigashira", label: "Mrigashira" },
  { key: "Ardra", label: "Ardra" },
  { key: "Punarvasu", label: "Punarvasu" },
  { key: "Pushya", label: "Pushya" },
  { key: "Ashlesha", label: "Ashlesha" },
  { key: "Magha", label: "Magha" },
  { key: "Purva Phalguni", label: "Purva Phalguni" },
  { key: "Uttara Phalguni", label: "Uttara Phalguni" },
  { key: "Hasta", label: "Hasta" },
  { key: "Chitra", label: "Chitra" },
  { key: "Swati", label: "Swati" },
  { key: "Vishakha", label: "Vishakha" },
  { key: "Anuradha", label: "Anuradha" },
  { key: "Jyeshtha", label: "Jyeshtha" },
  { key: "Moola", label: "Moola" },
  { key: "Purva Ashadha", label: "Purva Ashadha" },
  { key: "Uttara Ashadha", label: "Uttara Ashadha" },
  { key: "Shravana", label: "Shravana" },
  { key: "Dhanishta", label: "Dhanishta" },
  { key: "Shatabhisha", label: "Shatabhisha" },
  { key: "Purva Bhadrapada", label: "Purva Bhadrapada" },
  { key: "Uttara Bhadrapada", label: "Uttara Bhadrapada" },
  { key: "Revati", label: "Revati" }
];


export const MANGLIK_OPTIONS = [
  { key: "Manglik", label: "Manglik" },
  { key: "Non-Manglik", label: "Non-Manglik" },
  { key: "Partial Manglik", label: "Partial Manglik" },
  { key: "Not Sure", label: "Not Sure" }
];

export const hlaData = {
  options: {
    "HLA-A": ["HLA-A*01", "HLA-A*02", "HLA-A*03", "HLA-A*11", "HLA-A*23", "HLA-A*24", "HLA-A*25", "HLA-A*26", "HLA-A*29", "HLA-A*30", "HLA-A*31", "HLA-A*32", "HLA-A*33", "HLA-A*34", "HLA-A*68", "HLA-A*69", "Other"],
    "HLA-B": ["HLA-B*07", "HLA-B*08", "HLA-B*13", "HLA-B*15", "HLA-B*18", "HLA-B*27", "HLA-B*35", "HLA-B*37", "HLA-B*38", "HLA-B*39", "HLA-B*40", "HLA-B*44", "HLA-B*45", "HLA-B*49", "HLA-B*50", "HLA-B*51", "HLA-B*52", "HLA-B*53", "HLA-B*57", "HLA-B*58", "Other"],
    "HLA-C": ["HLA-C*01", "HLA-C*02", "HLA-C*03", "HLA-C*04", "HLA-C*05", "HLA-C*06", "HLA-C*07", "HLA-C*08", "HLA-C*12", "HLA-C*14", "HLA-C*15", "HLA-C*16", "Other"],
    "HLA-DPA1": ["HLA-DPA1*01", "HLA-DPA1*02", "HLA-DPA1*03", "HLA-DPA1*04", "Other"],
    "HLA-DPB1": ["HLA-DPB1*01", "HLA-DPB1*02", "HLA-DPB1*03", "HLA-DPB1*04", "HLA-DPB1*05", "Other"],
    "HLA-DQA1": ["HLA-DQA1*01", "HLA-DQA1*02", "HLA-DQA1*03", "HLA-DQA1*04", "HLA-DQA1*05", "Other"],
    "HLA-DQB1": ["HLA-DQB1*02", "HLA-DQB1*03", "HLA-DQB1*04", "HLA-DQB1*05", "HLA-DQB1*06", "Other"],
    "HLA-DRB1": ["HLA-DRB1*01", "HLA-DRB1*03", "HLA-DRB1*04", "HLA-DRB1*07", "HLA-DRB1*08", "HLA-DRB1*09", "HLA-DRB1*10", "HLA-DRB1*11", "HLA-DRB1*12", "HLA-DRB1*13", "HLA-DRB1*14", "HLA-DRB1*15", "HLA-DRB1*16", "Other"],
    "HLA-DRB3": ["DRB3*01", "DRB3*02", "DRB3*03", "Other"],
    "HLA-DRB4": ["DRB4*01", "Other"],
    "HLA-DRB5": ["DRB5*01", "Other"]
  },
  descriptions: {
    // Locus Descriptions
    "HLA-A": "Human Leukocyte Antigen A - involved in immune system regulation and presentation of peptides from inside the cell",
    "HLA-B": "Human Leukocyte Antigen B - plays a critical role in the immune system by presenting peptide antigens to T-cells",
    "HLA-C": "Human Leukocyte Antigen C - involved in immune system regulation, particularly in natural killer cell function",
    "HLA-DPA1": "Human Leukocyte Antigen DP alpha chain - involved in antigen presentation to immune cells",
    "HLA-DPB1": "Human Leukocyte Antigen DP beta chain - works with DPA1 to present antigens to T-cells",
    "HLA-DQA1": "Human Leukocyte Antigen DQ alpha chain - involved in immune response and associated with autoimmune diseases",
    "HLA-DQB1": "Human Leukocyte Antigen DQ beta chain - forms heterodimers with DQA1 to present antigens",
    "HLA-DRB1": "Human Leukocyte Antigen DR beta chain - critical for immune response and associated with many autoimmune conditions",
    "HLA-DRB3": "Human Leukocyte Antigen DR beta chain 3 - variant of DRB involved in immune response",
    "HLA-DRB4": "Human Leukocyte Antigen DR beta chain 4 - variant of DRB involved in immune response",
    "HLA-DRB5": "Human Leukocyte Antigen DR beta chain 5 - variant of DRB involved in immune response",

    // HLA-A Alleles
    "HLA-A*01": "Associated with slower HIV progression and certain autoimmune diseases",
    "HLA-A*02": "Most common HLA-A allele in many populations, associated with some cancer immunotherapies",
    "HLA-A*03": "Associated with hemochromatosis and some autoimmune conditions",
    "HLA-A*11": "Common in Asian populations; associated with control of Epstein-Barr virus",
    "HLA-A*23": "Studied in contexts of infectious disease and transplantation",
    "HLA-A*24": "Common in Asian populations; associated with Behçet's disease and drug hypersensitivity",
    "HLA-A*25": "A less common variant with various studied associations",
    "HLA-A*26": "Found with varying frequencies across populations",
    "HLA-A*29": "Associated with the eye disease Birdshot chorioretinopathy",
    "HLA-A*30": "Studied in the context of HIV and other infectious diseases",
    "HLA-A*31": "Strongly associated with carbamazepine-induced hypersensitivity reactions",
    "HLA-A*32": "A less common allele with various population-specific studies",
    "HLA-A*33": "Common in Asian and Middle Eastern populations",
    "HLA-A*34": "A relatively rare allele",
    "HLA-A*68": "A broad serotype split into many common alleles",
    "HLA-A*69": "A relatively rare allele",

    // HLA-B Alleles
    "HLA-B*07": "Associated with psoriasis, uveitis, and altered HIV progression",
    "HLA-B*08": "Part of a haplotype strongly linked to numerous autoimmune diseases",
    "HLA-B*13": "Associated with protection against severe malaria in some studies",
    "HLA-B*15": "A broad group; includes alleles linked to carbamazepine hypersensitivity",
    "HLA-B*18": "Associated with faster HIV disease progression",
    "HLA-B*27": "Strongly associated with ankylosing spondylitis and other seronegative spondyloarthropathies",
    "HLA-B*35": "Associated with faster HIV disease progression",
    "HLA-B*37": "A less common allele with various associations",
    "HLA-B*38": "Linked to psoriasis and other autoimmune conditions",
    "HLA-B*39": "Associated with Takayasu's arteritis",
    "HLA-B*40": "A broad group studied in various disease contexts",
    "HLA-B*44": "One of the most common alleles in European populations",
    "HLA-B*45": "Associated with protection against severe malaria",
    "HLA-B*49": "Studied in the context of type 1 diabetes and other autoimmune diseases",
    "HLA-B*50": "A less common allele",
    "HLA-B*51": "Strongly associated with Behçet's disease",
    "HLA-B*52": "Associated with Takayasu's arteritis",
    "HLA-B*53": "Associated with protection against severe malaria",
    "HLA-B*57": "Associated with slow HIV progression and hypersensitivity to abacavir",
    "HLA-B*58": "Strongly associated with allopurinol-induced severe hypersensitivity",

    // HLA-C Alleles
    "HLA-C*01": "Involved in HIV control and natural killer (NK) cell education",
    "HLA-C*02": "Studied in HIV and transplantation outcomes",
    "HLA-C*03": "A common allele with various general associations",
    "HLA-C*04": "Associated with a higher risk of ulcerative colitis",
    "HLA-C*05": "A less common allele",
    "HLA-C*06": "Strongly associated with psoriasis vulgaris",
    "HLA-C*07": "A very common allele; high expression is linked to better HIV control",
    "HLA-C*08": "A less common allele",
    "HLA-C*12": "Studied in various immunological contexts",
    "HLA-C*14": "A less common allele",
    "HLA-C*15": "Found in various populations",
    "HLA-C*16": "A less common allele",

    // HLA-DPA1 Alleles
    "HLA-DPA1*01": "A common allele group for the alpha chain of the DP molecule",
    "HLA-DPA1*02": "Another common allele group",
    "HLA-DPA1*03": "A less frequent allele group",
    "HLA-DPA1*04": "A less frequent allele group",

    // HLA-DPB1 Alleles
    "HLA-DPB1*01": "A common allele group for the beta chain of the DP molecule",
    "HLA-DPB1*02": "A common allele group",
    "HLA-DPB1*03": "A common allele group",
    "HLA-DPB1*04": "A common allele group; key in transplant matching",
    "HLA-DPB1*05": "A common allele group",

    // HLA-DQA1 Alleles
    "HLA-DQA1*01": "Often part of haplotypes linked to celiac disease and type 1 diabetes",
    "HLA-DQA1*02": "Part of haplotypes associated with autoimmune risk",
    "HLA-DQA1*03": "A broad group with various associations",
    "HLA-DQA1*04": "A less common group",
    "HLA-DQA1*05": "A key component of the risk haplotype for narcolepsy and celiac disease",

    // HLA-DQB1 Alleles
    "HLA-DQB1*02": "Strongest genetic risk factor for celiac disease; also linked to type 1 diabetes",
    "HLA-DQB1*03": "A broad group; includes alleles associated with autoimmune thyroid disease",
    "HLA-DQB1*04": "A less common group",
    "HLA-DQB1*05": "Part of the risk haplotype for narcolepsy",
    "HLA-DQB1*06": "Associated with narcolepsy and multiple sclerosis",

    // HLA-DRB1 Alleles
    "HLA-DRB1*01": "Associated with rheumatoid arthritis and pemphigus vulgaris",
    "HLA-DRB1*03": "Part of a haplotype linked to many autoimmune diseases (e.g., SLE)",
    "HLA-DRB1*04": "Associated with rheumatoid arthritis and type 1 diabetes",
    "HLA-DRB1*07": "Associated with multiple sclerosis (protective) and narcolepsy",
    "HLA-DRB1*08": "Associated with type 1 diabetes and primary sclerosing cholangitis",
    "HLA-DRB1*09": "Associated with type 1 diabetes in East Asian populations",
    "HLA-DRB1*10": "A less common allele group",
    "HLA-DRB1*11": "A common allele group with various associations",
    "HLA-DRB1*12": "A less common allele group",
    "HLA-DRB1*13": "Often associated with protective effects in type 1 diabetes and malaria",
    "HLA-DRB1*14": "Studied in various autoimmune and infectious contexts",
    "HLA-DRB1*15": "Strongly associated with multiple sclerosis",
    "HLA-DRB1*16": "A less common allele group",

    // HLA-DRB3, DRB4, DRB5 Alleles
    "DRB3*01": "Encodes the HLA-DR52 specificity, involved in immune response",
    "DRB3*02": "Another common variant of DRB3",
    "DRB3*03": "A variant of DRB3",
    "DRB4*01": "Encodes the HLA-DR53 specificity",
    "DRB5*01": "Encodes the HLA-DR51 specificity; often co-expressed with DRB1*15",

    // "Other" category for all groups
    "Other": "A catch-all for any other allele not specifically listed"
  }
};

// HLA Test Questions Structure
export const hlaQuestions = {
  step1: [
    { id: "HLA-A1", name: "First HLA-A allele", type: "HLA-A" },
    { id: "HLA-A2", name: "Second HLA-A allele", type: "HLA-A" },
    { id: "HLA-B1", name: "First HLA-B allele", type: "HLA-B" },
    { id: "HLA-B2", name: "Second HLA-B allele", type: "HLA-B" },
    { id: "HLA-C1", name: "First HLA-C allele", type: "HLA-C" },
    { id: "HLA-C2", name: "Second HLA-C allele", type: "HLA-C" }
  ],
  step2: [
    { id: "HLA-DPA11", name: "First HLA-DPA1 allele", type: "HLA-DPA1" },
    { id: "HLA-DPA12", name: "Second HLA-DPA1 allele", type: "HLA-DPA1" },
    { id: "HLA-DPB11", name: "First HLA-DPB1 allele", type: "HLA-DPB1" },
    { id: "HLA-DPB12", name: "Second HLA-DPB1 allele", type: "HLA-DPB1" },
    { id: "HLA-DQA11", name: "First HLA-DQA1 allele", type: "HLA-DQA1" },
    { id: "HLA-DQA12", name: "Second HLA-DQA1 allele", type: "HLA-DQA1" },
    { id: "HLA-DQB11", name: "First HLA-DQB1 allele", type: "HLA-DQB1" },
    { id: "HLA-DQB12", name: "Second HLA-DQB1 allele", type: "HLA-DQB1" }
  ],
  step3: [
    { id: "HLA-DRB11", name: "First HLA-DRB1 allele", type: "HLA-DRB1" },
    { id: "HLA-DRB12", name: "Second HLA-DRB1 allele", type: "HLA-DRB1" },
    { id: "HLA-DRB3", name: "HLA-DRB3 allele", type: "HLA-DRB3" },
    { id: "HLA-DRB4", name: "HLA-DRB4 allele", type: "HLA-DRB4" },
    { id: "HLA-DRB5", name: "HLA-DRB5 allele", type: "HLA-DRB5" }
  ]
};